/* container.tsx generated by @compiled/babel-plugin v0.32.2 */
import "./container.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
var containerStyles = null;
/* Use max-width so the component can shrink on smaller viewports. */
var wideContainerStyles = null;
var narrowContainerStyles = null;
/**
 * __Container__
 *
 * Upper level container for Empty State.
 *
 * @internal
 */
var Container = function Container(_ref) {
  var children = _ref.children,
    width = _ref.width,
    testId = _ref.testId;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": testId,
    className: ax(["_18s81efg _y3gn1h6o", width === 'narrow' ? "_p12fko4j" : "_p12f1pl1"]),
    style: {
      "--_129ypg0": ix("var(--ds-space-600, 48px)".concat(" auto"))
    }
  }, children);
};
export default Container;